import styled, { css } from "styled-components/macro";

export const TextInfoContainer = styled.div<{
  width?: number;
  alignCenter?: boolean;
  border?: boolean;
  p?: string;
  background?: string;
}>`
  width: 100%;
  color: ${(props) => props.color || props.theme.colors.text};
  background-color: ${(props) => props.background || "initial"};
  margin: 16px 0;
  ${(props) =>
    props.alignCenter &&
    css`
      text-align: center;
    `};
  ${(props) =>
    props.border && `border: 1px solid ${props.theme.colors.border}`};
  ${(props) => props.border && `border-radius: 4px`};
  ${(props) => props.p && `padding: ${props.p}`};

  & h1 {
    margin-bottom: 24px;
  }
  & h2 {
    margin-bottom: 8px;
  }
  & div {
    p:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  & > p {
    font-size: 16px;

    ${(props) => props.width && `max-width: ${props.width}px`};
    margin: 0;
    & > span {
      color: ${(props) => props.theme.colors.textDimmed};
    }
  }
  & > p:first-of-type {
    font-weight: ${(props) => props.theme.font.weightBold};
    margin-top: 60px;
  }

  & button {
    margin-top: 24px;
    font-weight: 600;
  }
`;

export const ButtonGroup = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
  height: 100%;
  & > button {
    font-size: ${(props) => props.theme.font.size};
    height: 37px;
    font-weight: ${(props) => props.theme.font.weightBold};
  }
  & button:nth-last-child(1) {
    margin-left: 10px;
  }
`;